import React, { useEffect, useState } from 'react';
import { Droppable } from 'react-beautiful-dnd';

/**
 * Droppable, совместимый с React 18 StrictMode.
 *
 * react-beautiful-dnd 13 не поддерживает StrictMode: в dev-режиме StrictMode
 * монтирует, размонтирует и снова монтирует компоненты, библиотека теряет
 * регистрацию зоны («Cannot find droppable entry with id …») и перетаскивание
 * не запускается. Рендер Droppable на кадр позже обходит это; в production-
 * сборке разница — только этот один кадр.
 */
export default function StrictModeDroppable({ children, ...props }) {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const animation = requestAnimationFrame(() => setEnabled(true));

    return () => {
      cancelAnimationFrame(animation);
      setEnabled(false);
    };
  }, []);

  if (!enabled) {
    return null;
  }

  return <Droppable {...props}>{children}</Droppable>;
}
